import { CartId } from 'lib/types'
import { RootState } from 'lib/core/data/reducer'

export const getBillingAddress = (cartId: CartId) => (state: RootState) => {
  const slice = state.quote.setBillingAddress[cartId ?? ''] ?? {}
  return slice
}
